module.exports = "img/flags/TT.cf3c1a5.png";